export async function cargarDireccionesCompletas(axios, filtros) {
  const direcciones = []
  let pagina = 1
  while (true) {
    const respuesta = await axios.get('direcciones', { params: { ...filtros, page: pagina, itemsPerPage: 100 } })
    direcciones.push(...respuesta.data['hydra:member'])
    const siguiente = respuesta.data['hydra:view']?.['hydra:next']
    if (!siguiente) return direcciones
    const siguientePagina = Number(new URL(siguiente, 'http://paginacion.local').searchParams.get('page'))
    if (!Number.isSafeInteger(siguientePagina) || siguientePagina <= pagina) throw new Error('La paginación de direcciones no es válida.')
    pagina = siguientePagina
  }
}

export function normalizarBusquedaDireccion(valor) {
  return String(valor ?? '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()
}

export function textoBusquedaDireccion(direccion) {
  return [direccion.nombre, direccion.codigo, direccion.nif, direccion.razonSocial, direccion.tipo,
    direccion.direccion, direccion.codigoPostal, direccion.email, direccion.telefono, direccion.telefono2,
    direccion.rgseaa, direccion.ria, direccion.rsi, direccion.numeroCertificado, direccion.entidadCertificadora,
    direccion.descripcion, direccion.localidad?.nombre, direccion.localidad?.municipioNombre,
    direccion.localidad?.provinciaNombre, direccion.localidad?.comunidadNombre, direccion.localidad?.paisNombre,
  ].map(normalizarBusquedaDireccion).join('\u0000')
}
